import { createContext } from "react";

import { RegionSearchUser, UserSearchQuery } from "../types/search-display";

type UserSearchQueryContextType = {
  userSearchQueryState: UserSearchQuery;
  setUserSearchQueryState: React.Dispatch<
    React.SetStateAction<UserSearchQuery>
  >;
};

type UsUserSearchContextType = {
  usRegionSearchUsers: RegionSearchUser;
  setUsRegionSearchUsers: React.Dispatch<
    React.SetStateAction<RegionSearchUser>
  >;
};

type EuUserSearchContextType = {
  euRegionSearchUsers: RegionSearchUser;
  setEuRegionSearchUsers: React.Dispatch<
    React.SetStateAction<RegionSearchUser>
  >;
};

type AuUserSearchContextType = {
  auRegionSearchUsers: RegionSearchUser;
  setAuRegionSearchUsers: React.Dispatch<
    React.SetStateAction<RegionSearchUser>
  >;
};

export const UserSearchQueryContext = createContext<UserSearchQueryContextType>(
  {} as UserSearchQueryContextType
);

export const UsUserSearchContext = createContext<UsUserSearchContextType>(
  {} as UsUserSearchContextType
);

export const EuUserSearchContext = createContext<EuUserSearchContextType>(
  {} as EuUserSearchContextType
);

export const AuUserSearchContext = createContext<AuUserSearchContextType>(
  {} as AuUserSearchContextType
);
